import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import { checkboxData } from './checkboxData';
import './style.css'
import { useUserAuth } from '../../context/UserAuthContext';
import { useFormik } from 'formik';
import { magicianTtkSchema } from '../schemas';
import axios from "axios";
import ThinksToKnowStatus from './ThinksToKnowStatus';

const MagicianTTK = () => {
    const [ttkEditMode, setTtkEditMode] = useState(false)
    const { user, language, token } = useUserAuth();
    const merchant_id = user.uid;
    const [merchant, setMerchant] = useState({});

    const [workingSince, setWorkingSince] = useState([])
    const [eventtype, setEventtype] = useState([])
    const [requirement, setRequirment] = useState([])
    const [duration, setDuration] = useState([])
    const [travelPreference, setTravelPreference] = useState([])
    const [areaOfWorking, setAreaofWorking] = useState([])

    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(
                `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            const data = res.data.data;
            const details = data[0].details;
            // const details = rawDetails ? JSON.parse(rawDetails) : null;
            if (details) {
                setMerchant(details);
                // formik.setValues(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };

    useEffect(() => {
        if (!merchant_id) return
        getSingleDocumentHandler()
    }, [merchant_id, token])

    const workingSinceOption = checkboxData.workSinceOption;
    const eventTypeOption = checkboxData.eventTypeMagician;
    const requirmentOption = checkboxData.requirementMagician;
    const durationOption = checkboxData.durationMagicians;
    const areaofServicesOption = checkboxData.areaOfWorking;

    const formik = useFormik({
        initialValues: {
            coverdofevents: merchant?.coverdofevents || '',
            eventtype: merchant?.eventtype || [],
            workingSince: merchant?.workingSince || [],
            requirement: merchant?.requirement || [],
            duration: merchant?.duration || [],
            areaOfWorking: merchant?.areaOfWorking || [],
        },
        enableReinitialize: true,
        validationSchema: magicianTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: { ...values },
                };

                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(values);
                    formik.setValues(values);
                    setTtkEditMode(false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(false);
                }

            } catch (error) {
                console.error(`Error ${error}`);
                toast.error('An error occurred while submitting the data.');
            }
        },
    });
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header  text-white text-center ' style={{ backgroundColor: '#085f9a' }}>
                                <h5> {language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <>
                                            <div className='table-responsive'>
                                                <table className='table text-center' cellPadding={0} cellSpacing={0} style={{ border: '1px solid #fff ' }}>
                                                    <tbody className='ttk_preview'>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th style={{ width: '25%' }}>Working Since</th>
                                                            <th style={{ width: '25%' }}>Event Type</th>
                                                            <th style={{ width: '25%' }}>Requirements</th>
                                                            <th style={{ width: '25%' }}>Duration of the Show</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.workingSince?.map((item, index) => {
                                                                    return <span key={index}>{item.value}</span>
                                                                })
                                                            }</td>

                                                            <td>{
                                                                merchant.eventtype
                                                                    ?.map((item, index) => {
                                                                        return <>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span key={index}>{item.value} </span>
                                                                        </>
                                                                    })
                                                            }</td>

                                                            <td>{
                                                                merchant.requirement
                                                                    ?.map((item, index) => {
                                                                        return <>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span key={index}>{item.value} </span>
                                                                        </>
                                                                    })
                                                            }</td>

                                                            <td>{
                                                                merchant.duration
                                                                    ?.map((item, index) => {
                                                                        return <>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span key={index}>{item.value} </span>
                                                                        </>
                                                                    })
                                                            }</td>


                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th>No. of Events Covered</th>
                                                            <th>Area of Services</th>

                                                        </tr>
                                                        <tr>

                                                            <td> {merchant.coverdofevents}</td>
                                                            <td>{
                                                                merchant.areaOfWorking
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span key={index}>{item.value} </span>
                                                                            </>
                                                                        )
                                                                    })
                                                            }</td>

                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </>
                                    )
                                }
                                <center>
                                    <button className='btn text-white mb-2' style={{ backgroundColor: '#085f9a' }} onClick={() => setTtkEditMode(!ttkEditMode)}>{`${merchant ? 'Make Changes' : 'Tell me more about yourself'}`}</button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Working Since <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={workingSinceOption}
                                                            selected
                                                            value={formik.values.workingSince}
                                                            onChange={(workingSince) => formik.setFieldValue('workingSince', workingSince)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.workingSince && formik.errors.workingSince ? (
                                                            <div className="text-danger">{formik.errors.workingSince}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Area Of Services <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={areaofServicesOption}
                                                            selected
                                                            value={formik.values.areaOfWorking}
                                                            onChange={(areaOfWorking) => formik.setFieldValue('areaOfWorking', areaOfWorking)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.areaOfWorking && formik.errors.areaOfWorking ? (
                                                            <div className="text-danger">{formik.errors.areaOfWorking}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Event Type <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={eventTypeOption}
                                                            selected
                                                            value={formik.values.eventtype}
                                                            onChange={(eventtype) => formik.setFieldValue('eventtype', eventtype)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.eventtype && formik.errors.eventtype ? (
                                                            <div className="text-danger">{formik.errors.eventtype}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Requirements <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={requirmentOption}
                                                            selected
                                                            value={formik.values.requirement}
                                                            onChange={(requirement) => formik.setFieldValue('requirement', requirement)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.requirement && formik.errors.requirement ? (
                                                            <div className="text-danger">{formik.errors.requirement}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Duration of the Show <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={durationOption}
                                                            selected
                                                            value={formik.values.duration}
                                                            onChange={(duration) => formik.setFieldValue('duration', duration)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.duration && formik.errors.duration ? (
                                                            <div className="text-danger">{formik.errors.duration}</div>
                                                        ) : null}
                                                    </div>
                                                </div>


                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>No. of Events Covered <span className='text-danger'>*</span></label>
                                                        <input
                                                            type='number'
                                                            placeholder='No. of Events Covered'
                                                            className='form-control'
                                                            name="coverdofevents"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.coverdofevents}
                                                        />
                                                        {formik.touched.coverdofevents && formik.errors.coverdofevents ? (
                                                            <div className="text-danger">{formik.errors.coverdofevents}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-group'>
                                                <button className='btn text-white' type='submit' style={{ backgroundColor: '#085f9a' }}>Submit</button>
                                            </div>
                                        </form>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
export default MagicianTTK